export const lightTheme = {
  primary: "#7E549F",
  siderBg: "#001529",
  headerBg: "rgba(255, 255, 255, 0.1)",
  footerBg: "#fff",
  border: "#f0f0f0",
  white: "#ffff",
  black: "#000",
  borderLight: "#d9d9d9",
  mainBlue: "#1E6CB6",
  mainYellow: "#FADD07",
  mainRed: "#F03D40",
  mainGreen: "#007F00",
  lightGreen: "#CDFFCD",
  gray: "#E5E5E5",
  skyBlue: "#4DA8DD",
  mainGradient: "linear-gradient(91deg, #F03D40 -0.73%, #FADD07 118.71%)",
  placeholder: "rgba(0,0,0,0.4)",
  lightGreenTag: "#3c853c",
  lightRedTag: "#d93434",
};

export const darkTheme = {
  primary: "#7E549F",
  siderBg: "#001529",
  headerBg: "rgba(255, 255, 255, 0.5)",
  footerBg: "#fff",
  border: "#f0f0f0",
  white: "#ffff",
  black: "#000",
  borderLight: "#d9d9d9",
  mainBlue: "#1E6CB6",
  mainYellow: "#FADD07",
  mainRed: "#F03D40",
  mainGreen: "#007F00",
  lightGreen: "#CDFFCD",
  gray: "#E5E5E5",
  skyBlue: "#4DA8DD",
  mainGradient: "linear-gradient(91deg, #F03D40 -0.73%, #FADD07 118.71%)",
  placeholder: "rgba(0,0,0,0.4)",
  lightGreenTag: "#3c853c",
  lightRedTag: "#d93434",
};
